/* eslint-disable complexity */
// 群接龙详情
import React, { useState, useEffect, useCallback, useMemo } from "react";
import "./index.less";
import {
  Drawer,
  Form,
  Space,
  Button,
  Input,
  message as toast,
  Spin,
  Dropdown,
  Menu,
  Modal,
  Popover,
  Tabs,
  Empty
} from "antd";
import { Employee } from "@/types/chat";
import IconFont from "@/components/icon";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import i18n from "@/i18n";
import ImService from "@/server/ImService";
import { isEqualTeam } from "@/utils/chat/message";
import { deleteSolitaire, getSolitaire, uptSolitaire } from "@/api/Solitaire";
import { Avatar } from "@/baseComponents/Avatar";
import CopyClipboard from "copy-to-clipboard";
import { changeEgovUrl } from "@/utils/tools";
import { formate, Jlmate } from "@/utils/date";
import { isGroupAdmin, isGroupOwner } from "@/utils/chat/group";
import bus from "@/utils/bus";
import colors from "@/components/styles/colors";
import noticeImg from "@/assets/img/no-content.png";
import { EsuperviseSourceType, ICreateSuperviseData } from "@/types/supervise";

const { TextArea } = Input;
const { TabPane } = Tabs;

interface MessageOperateProps {
  currentEmployee: Employee;
  connectState: ConnectState;
  solitaireSoli?: boolean;
  updateSessionMessageMid: Function;
  openSolitaireDetails: (data: { isvisibles: boolean; solitaire: any }) => void;
  openSolitaireHis: (data: { isvisibles: boolean; solitaireSid: any }) => void;
  openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => void;
}
let solitaireUserList: any = [];
let solitaireObj = {
  solitaireUserId: "",
  appId: "",
  teamId: "",
  solitaireId: "",
  name: "",
  value: "",
  userId: "",
  status: 1
};
let solitaireUserId: any;
let resultSolitaire: any = [];
let userNameVal = "";
let groupRosterIdentity: any;
let sessionMessages: any[];
type IProps = Readonly<MessageOperateProps & ChatState>;

function SolitaireDetails(props: IProps) {
  const [t] = useTranslation("chat");
  const {
    currentEmployee,
    connectState,
    SolitaireDetailsVisible,
    solitaireId,
    openSolitaireDetails,
    openSolitaireHis,
    solitaireSoli,
    openCreateSuperviseModal,
    sessionMessageMap,
    SolitaireHisVisible
  } = props;
  const inputRef = React.useRef<any>(null);
  const btn = React.useRef<any>(null);
  const [tiems, settiems] = useState(false);
  const [descCon, setdescCon] = useState("");
  const [solitaire, setsolitaire] = useState<any>();
  const [det, setdet] = useState(false);
  const [disabled, setdisabled] = useState(false);
  const [loading, setloading] = useState(false);
  const [isloading, setisloading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [btnstyle, setbtnstyle] = useState({ display: "block" });
  const state: any = connectState;
  let indexs: number;

  // 取消
  const onClose = useCallback(() => {
    openSolitaireDetails({
      isvisibles: false,
      solitaire: ""
    });
    setsolitaire(undefined);
    setisloading(false);
    setdisabled(false);
    setdet(false);
    settiems(false);
    solitaireUserList = [];
    resultSolitaire = [];
    userNameVal = "";
  }, [openSolitaireDetails]);

  // 打开组接龙
  const handleSolitaireClick = useCallback(async () => {
    // 查询缓存
    const instance = ImService.getInstance();
    setloading(true);
    // if (state.state === ConnectState.OFFLINE) {
    //     return toast.error(i18n.t('Network Error'));
    // }
    const [result, err] = await getSolitaire({
      appId: currentEmployee.app,
      teamId: currentEmployee.teamId,
      userId: currentEmployee.userId,
      solitaireId: solitaireId,
      fromPage: 1
    });
    if (err) {
      onClose();
      toast.error(err);
      return;
    }
    if (result) {
      sessionMessages = sessionMessageMap[result.solitaire.businessId] || [];
      const rosters = await instance.getGroupRosters(result.solitaire.businessId, true);
      groupRosterIdentity = rosters?.filter((item) => {
        return (
          item.user?.pin === currentEmployee.userId && item.user?.teamId === currentEmployee.teamId
        );
      });
      groupRosterIdentity = groupRosterIdentity[0].identity;
      if (result.solitaire.status === 2) {
        settiems(true);
      } else {
        settiems(false);
      }
      setsolitaire(result);
      setloading(false);
      // 默认添加选项
      let isGroups = result.solitaire?.solitaireUserList?.map((item: any) => {
        if (item.userId === currentEmployee.userId && currentEmployee.teamId === item.teamId) {
          return "false";
        }
      });
      if (isGroups?.includes("false")) {
        return;
      }
      const AddBtn = btn.current;
      if (!btn.current) return;
      AddBtn.click();
      let TextRef: any = document.getElementById("TextRef");
      TextRef.focus();
    }
  }, [currentEmployee, solitaireId, sessionMessageMap, onClose]);

  useEffect(() => {
    if (SolitaireDetailsVisible) {
      handleSolitaireClick();
    }
  }, [SolitaireDetailsVisible, handleSolitaireClick]);

  // 参与群接龙
  function sendMessages2() {
    setisloading(true);
    solitaireUserList.push({
      solitaireUserId: "",
      appId: currentEmployee.app,
      teamId: currentEmployee.teamId,
      solitaireId: solitaireId,
      name: userNameVal ? userNameVal : currentEmployee.name,
      value: descCon,
      userId: currentEmployee.userId,
      status: 1
    });
    sendMessages();
  }

  // 保存接龙
  const sendMessages = useCallback(async () => {
    if (state.state === ConnectState.OFFLINE) {
      return toast.error(i18n.t("Network Error"));
    }
    let use: any;
    solitaire.solitaire?.solitaireUserList?.map((item: any) => {
      if (item.userId === currentEmployee.userId) {
        use = item.userId;
      }
    });
    await uptSolitaire({
      appId: currentEmployee.app,
      teamId: currentEmployee.teamId,
      userId: currentEmployee.userId,
      solitaireId: solitaire.solitaire?.solitaireId,
      solitaireUserList:
        det === true || solitaireUserList[0] === undefined
          ? ([resultSolitaire[0]] as any)
          : [solitaireUserList[0]]
    })
      .then((res) => {
        if (res[1]) {
          toast.error(res[1]);
        }
        if (use === solitaireObj.userId || det === true) {
          bus.emit("work:Solitaire:solitaireHistory", solitaire.solitaire.solitaireId);
        } else {
          bus.emit("work:Solitaire:solitaireHistory", solitaire.solitaire.solitaireId);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
    onClose();
  }, [state.state, solitaire, currentEmployee, det, onClose]);

  // 导出数据
  const onExport = (e: any) => {
    e.preventDefault();
    let personnel = "";
    solitaire.solitaire?.solitaireUserList?.filter((item: any, index: any) => {
      const inx = index + 1;
      personnel += inx + "、" + item.name + "：" + item.value + "\n";
    });
    const onExportText = `接龙名称：${solitaire.solitaire?.title} \n来源：${solitaire.solitaire?.sourceName} \n发起人：${solitaire.solitaire?.createName} \n目前有${solitaire.solitaire?.count}人参与 \n${personnel}`;
    CopyClipboard(onExportText);
    if (CopyClipboard(onExportText)) {
      toast.success("接龙数据文本已复制");
    }
  };

  // 删除数据
  const remove = (item: any, index: any) => {
    setdet(true);
    setdisabled(true);
    const remov: any = document.querySelectorAll(".items");
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < remov.length; i++) {
      if (item.solitaireUserId === remov[i].getAttribute("id")) {
        resultSolitaire.push(item);
        solitaireUserList.push(item);
        remov[i].style.display = "none";
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        index - 1;
        // solitaire.solitaire?.solitaireUserList?.map((item1: any, index: any) => {
        //   if (item.solitaireUserId === item1.solitaireUserId) {
        //     if (item1.userId !== currentEmployee.userId) {
        //       return;
        //     }
        //     // eslint-disable-next-line no-return-assign
        //     return (item.status = 0);
        //   }
        // });
        const userList = solitaire.solitaire?.solitaireUserList || [];
        const reIdx = userList.findIndex(
          (item1: any) =>
            item.solitaireUserId === item1.solitaireUserId &&
            item1.userId !== currentEmployee.userId
        );
        userList.splice(reIdx, 1);
        setsolitaire({
          ...solitaire,
          solitaire: { ...solitaire.solitaire, solitaireUserList: userList }
        });
      }
    }
  };

  // 获取数据
  function onValuesChange(e: any) {
    setdisabled(true);
    setdet(true);
    solitaire.solitaire?.solitaireUserList?.map((item: any) => {
      if (item.solitaireUserId === solitaireUserId) {
        resultSolitaire.push(item);
        solitaireUserList.push(item);
        // eslint-disable-next-line no-return-assign
        return (item.value = e.target.value);
      }
    });
  }

  function onNameChange(e: any) {
    setdisabled(true);
    solitaire.solitaire?.solitaireUserList?.map((item: any) => {
      // setdet(true);
      if (item.name !== e.target.value && item.userId === currentEmployee.userId) {
        resultSolitaire.push(item);
        solitaireUserList.push(item);
        // eslint-disable-next-line no-return-assign
        return (item.name = e.target.value);
      }
    });
  }

  // 删除接龙
  const deleteItem = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    await deleteSolitaire({
      solitaireId: solitaireId
    })
      .then(() => {
        toast.success("接龙已删除");
        if (SolitaireHisVisible) {
          bus.emit("work:Solitaire:solitaireHistory", solitaireId);
        }
        onClose();
      })
      .catch((err) => {
        console.log(err);
      });
    setIsModalOpen(false);
  };
  function visibleChange(visible: boolean) {
    setPopoverVisible(visible);
    setbtnstyle({ display: "block" });
  }
  const onTabchange = (activeKey: any) => {
    if (activeKey === "0") {
      setbtnstyle({ display: "block" });
    } else {
      setbtnstyle({ display: "none" });
    }
  };
  // 打开催办
  function handleOpenRecord(advanceUser: any, value: any) {
    const userList: any[] = [];
    if (advanceUser.length === undefined) {
      userList.push({
        userId: advanceUser?.userId,
        teamId: advanceUser?.teamId,
        appId: advanceUser?.appId,
        headImg: advanceUser?.headImg,
        realName: advanceUser?.realName
      });
      // });
    } else {
      // eslint-disable-next-line array-callback-return
      advanceUser.map((item: any) => {
        userList.push({
          userId: item?.userId,
          teamId: item?.teamId,
          appId: item?.appId,
          headImg: item?.headImg,
          realName: item?.realName
        });
      });
    }
    console.log("打开催办", userList);
    openCreateSuperviseModal({
      visible: true,
      createData: {
        id: solitaireId,
        title: value,
        userList,
        from: EsuperviseSourceType.SOLITAIRE
      }
    });
    setPopoverVisible(false);
    onClose();
  }

  const jurisdiction = useMemo(() => {
    if (!solitaire) return;
    return (
      (solitaire.solitaire?.createBy === currentEmployee.userId &&
        solitaire.solitaire?.teamId === currentEmployee.teamId) ||
      isGroupOwner(groupRosterIdentity) ||
      isGroupAdmin(groupRosterIdentity)
    );
  }, [currentEmployee.teamId, currentEmployee.userId, solitaire]);

  const isCreateBy = useMemo(() => {
    if (!solitaire) return;
    return (
      solitaire.solitaire?.createBy === currentEmployee.userId &&
      solitaire.solitaire?.status !== 2 &&
      solitaire.solitaire?.teamId === currentEmployee.teamId
    );
  }, [currentEmployee.teamId, currentEmployee.userId, solitaire]);

  if (!solitaire) return null;

  const footer = (
    <div>
      <Space align="end">
        <Button onClick={onClose}>取消</Button>
        {tiems === false && (
          <Button
            disabled={disabled === false ? true : false}
            type="primary"
            onClick={debounce(() => {
              sendMessages2();
            }, 500)}
          >
            发布
          </Button>
        )}
      </Space>
    </div>
  );

  const menu = (
    <Menu className="GroupSlitaireMenu">
      {jurisdiction ? (
        <Menu.Item>
          <span
            onClick={(e) => {
              onExport(e);
            }}
          >
            导出数据到剪贴板
          </span>
        </Menu.Item>
      ) : null}
      {!solitaireSoli && (
        <Menu.Item
          onClick={() => {
            openSolitaireHis({
              isvisibles: true,
              solitaireSid: solitaire.solitaire?.businessId
            });
            onClose();
          }}
        >
          <span>查看历史接龙</span>
        </Menu.Item>
      )}
      {solitaire.solitaire?.createBy === currentEmployee.userId ? (
        <Menu.Item onClick={deleteItem}>
          <span>删除</span>
        </Menu.Item>
      ) : null}
    </Menu>
  );

  const contentForm = (
    <Form labelAlign="left" labelCol={{ span: 2 }} wrapperCol={{ span: 22 }}>
      {solitaire.solitaire?.solitaireUserList?.map((item: any, index: any) => {
        indexs = index + 1;
        return (
          <div key={index} className="items" id={item.solitaireUserId}>
            <Form.Item
              label={
                currentEmployee.userId === item.userId &&
                !tiems &&
                item.teamId === currentEmployee.teamId ? (
                  <IconFont
                    type="iconbutton_app_yichu"
                    className="removeIcon"
                    onClick={() => {
                      remove(item, index);
                    }}
                  />
                ) : (
                  index + 1
                )
              }
              required={false}
              colon={false}
            >
              <Form.Item
                // {...item}
                // refs={divEl}
                label={
                  currentEmployee.userId === item.userId && !tiems ? (
                    <IconFont
                      type="iconic_button_zjl_yichu"
                      className="removeIcon"
                      onClick={() => {
                        remove(item, index);
                      }}
                    />
                  ) : (
                    index + 1
                  )
                }
                style={{ padding: index >= 10 ? "4px" : "8px" }}
                validateTrigger={["onChange", "onBlur"]}
                noStyle
                name={["names1", "value"]}
              >
                <div className="names">
                  {item.userId !== currentEmployee.userId ||
                  !isEqualTeam(item, currentEmployee) ||
                  tiems ? (
                    <div className="defaultName">
                      <span
                        style={{
                          margin: "0 8px",
                          color: "#62656D",
                          whiteSpace: "pre"
                        }}
                      >
                        {item.name}
                      </span>
                      <p
                        style={{
                          color: `${colors.black2}`,
                          wordBreak: "break-all"
                        }}
                      >
                        {solitaire.solitaire?.open === 1 ||
                        jurisdiction ||
                        (isEqualTeam(item, currentEmployee) &&
                          item.userId === currentEmployee.userId)
                          ? item.value
                          : "* * *"}
                      </p>
                    </div>
                  ) : (
                    <>
                      <Input
                        className="hover"
                        placeholder="姓名"
                        allowClear={true}
                        defaultValue={
                          jurisdiction ||
                          (isEqualTeam(item, currentEmployee) &&
                            item.userId === currentEmployee.userId)
                            ? item.name
                            : "* * *"
                        }
                        style={{
                          width: "110px",
                          marginRight: "12px",
                          color:
                            item.userId === currentEmployee.userId && !tiems
                              ? `${colors.black2}`
                              : "#8F959E"
                          // padding:
                          //     item.userId === currentEmployee.userId && !tiems
                          //         ? '4px 11px'
                          //         : '4px 0px 4px 10px',
                        }}
                        onChange={(e: any) => {
                          onNameChange(e);
                        }}
                        disabled={!tiems ? false : true}
                      />
                      <TextArea
                        placeholder="接龙内容"
                        disabled={!tiems ? false : true}
                        autoSize={{
                          minRows: 1,
                          maxRows: 4
                        }}
                        maxLength={100}
                        style={{
                          resize: "none",
                          color:
                            item.userId === currentEmployee.userId &&
                            isEqualTeam(item, currentEmployee) &&
                            !tiems
                              ? `${colors.black2}`
                              : "#8F959E"
                          // padding:
                          //     item.name.length > 3
                          //         ? '4px 10px 4px 2px'
                          //         : '4px 11px',
                        }}
                        defaultValue={item.value}
                        onChange={(e: any) => {
                          solitaireUserId = item.solitaireUserId;
                          onValuesChange(e);
                        }}
                      />
                    </>
                  )}
                </div>
              </Form.Item>
            </Form.Item>
          </div>
        );
      })}
    </Form>
  );

  const tabList = [
    `未参与 ${solitaire.solitaire?.unansweredNum}`,
    `已参与 ${solitaire.solitaire?.repliedNum}`
  ];
  const tabs = (
    <div onClick={(e) => e.stopPropagation()} style={{ height: "100%" }}>
      {solitaire.solitaire && (
        <Tabs onChange={(activeKey) => onTabchange(activeKey)} tabBarGutter={70}>
          {tabList.map((tabItem, inx) => {
            const user =
              inx === 0
                ? solitaire.solitaire?.unReadMemberList
                : solitaire.solitaire.readMemberList;
            if (!user || user?.length === 0) {
              return (
                <TabPane tab={tabItem} key={inx}>
                  <div className="empty_item">
                    <Empty
                      image={noticeImg}
                      imageStyle={{
                        height: 100
                      }}
                      description={<span style={{ color: "#62656D" }}>暂无数据</span>}
                    />
                  </div>
                </TabPane>
              );
            }
            return (
              <TabPane tab={tabItem} key={inx}>
                {user.map((item: any, index: any) => {
                  if (item === undefined) return null;
                  let dept = "";
                  let proTitle = "";
                  if (item.labelInfoList?.[1]) {
                    dept = item.labelInfoList[1].name;
                  }
                  if (item.labelInfoList?.[2]) {
                    proTitle = item.labelInfoList[2].name;
                  }
                  return (
                    <div
                      className="solitaire_user"
                      key={index}
                      // onClick={(e) => {
                      //     e.stopPropagation();
                      //     openUserCard(item);
                      // }}
                    >
                      <div className="solitaire_left">
                        <Avatar
                          className="imgAvatar"
                          name={item.realName || ""}
                          src={changeEgovUrl(item.headImg)}
                          // onClick={() => openUserCard(item)}
                        />
                        <div className="solitaire_left_user">
                          <span className="solitaire_left_name ellipsis">{item.realName}</span>
                          <span className="solitaire_left_dept ellipsis">{`${dept}-${proTitle}`}</span>
                        </div>
                      </div>
                      {inx === 0 && isCreateBy && (
                        <div
                          className="solitaire_right"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleOpenRecord(item, solitaire.solitaire?.title);
                          }}
                        >
                          催办
                        </div>
                      )}
                      {inx === 0 && isCreateBy && (
                        <div className="solitaire_button" style={btnstyle}>
                          <Button
                            block
                            type="primary"
                            htmlType="submit"
                            onClick={debounce(() => {
                              handleOpenRecord(
                                solitaire.solitaire.unReadMemberList,
                                solitaire.solitaire?.title
                              );
                            }, 500)}
                          >
                            全部催办
                          </Button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </TabPane>
            );
          })}
        </Tabs>
      )}
    </div>
  );
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      <Drawer
        width={445}
        title={t("solitaire")}
        className="solitaireDetails"
        onClose={onClose}
        mask={true}
        visible={SolitaireDetailsVisible}
        destroyOnClose={true}
        placement="right"
        footer={tiems === true ? null : footer}
      >
        {isloading === false ? (
          <>
            <div className="headers">
              <div className="headers-left">
                <Avatar
                  src={changeEgovUrl(solitaire.solitaire?.headImg)}
                  name={solitaire.solitaire?.createName || ""}
                  styleObj={{
                    width: 40,
                    height: 40,
                    borderRadius: "6px"
                  }}
                />
                <div className="headers-name">
                  <span className="name">{solitaire.solitaire?.createName}</span>
                  <span className="time">更新于 {formate(solitaire.solitaire?.gmtCreate)}</span>
                </div>
              </div>
              <Dropdown placement="bottomRight" overlay={menu}>
                <IconFont type="iconlog_more" />
              </Dropdown>
            </div>
            <div className="solitaire_user">
              <span style={{ whiteSpace: "nowrap", color: `${colors.black2}` }}>接收人：</span>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer"
                }}
                onClick={() => {
                  setPopoverVisible(true);
                }}
              >
                <div className="solitaire_user1">
                  <span>共{solitaire.solitaire?.totalNum}人</span>
                  <span>
                    （已参与{solitaire.solitaire?.repliedNum}
                    人， 未参与{solitaire.solitaire?.unansweredNum}人）
                  </span>
                </div>
                <Popover
                  overlayClassName={
                    btnstyle.display === "block" &&
                    solitaire.solitaire?.createBy === currentEmployee.userId &&
                    !tiems
                      ? "solitaire_Popover"
                      : "solitaire_Popover1"
                  }
                  trigger="click"
                  placement="bottom"
                  content={tabs}
                  onVisibleChange={visibleChange}
                  visible={popoverVisible}
                >
                  <div className="solitaire_user2">
                    <IconFont
                      className="solitaire_icon"
                      type="iconic_profile_next"
                      clstag="pageclick|keycount|focus_chat_01_1602584371145|47"
                    />
                  </div>
                </Popover>
              </div>
            </div>
            <div className="content">
              <h3 style={{ fontWeight: 700 }}>{solitaire.solitaire?.title}</h3>
              <p
                style={{
                  color: "#62656D",
                  marginBottom: "15px",
                  whiteSpace: "pre-wrap"
                }}
              >
                {solitaire.solitaire?.desc}
              </p>
              <div
                style={{
                  marginBottom: "16px",
                  color: "#62656D"
                }}
              >
                <div className="isTimes">
                  <span style={{ color: `${colors.black2}` }}>
                    {solitaire.solitaire?.deadLine === null
                      ? "无截止时间"
                      : Jlmate(solitaire.solitaire?.deadLine)}
                  </span>
                  &nbsp;&nbsp;
                  {solitaire.solitaire?.deadLine && (
                    <span
                      style={{
                        color: tiems === true ? "#EE0A24" : "#62656D"
                      }}
                    >
                      {tiems === true ? "已截止" : "截止"}
                    </span>
                  )}
                </div>
                {solitaire.solitaire?.createBy === currentEmployee.userId ? (
                  <span style={{ display: "block", marginTop: 15 }}>
                    {solitaire.solitaire?.open === 0 ? "隐藏结果" : "公开结果"}
                  </span>
                ) : null}
              </div>
            </div>
            <div className="con-bom">
              {loading === false ? (
                <div>{contentForm}</div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <Spin tip="加载中..." spinning={loading} />
                </div>
              )}
              <Form
                // onValuesChange={ValuesChange}
                labelAlign="left"
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Form.List name="names">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field, index) => {
                        return (
                          <Form.Item
                            label={
                              fields.length > 0 ? (
                                <IconFont
                                  type="iconic_button_zjl_yichu"
                                  className="removeIcon"
                                  onClick={() => {
                                    remove(field.name);
                                    solitaireUserList.splice(index, 1);
                                    setdet(true);
                                  }}
                                />
                              ) : (
                                index + indexs + 1 || index + 1
                              )
                            }
                            required={false}
                            key={field.key}
                            colon={false}
                          >
                            <Form.Item
                              {...field}
                              validateTrigger={["onChange", "onBlur"]}
                              noStyle
                              name={[field.name, "value"]}
                            >
                              <div className="names">
                                <Input
                                  className="hover"
                                  allowClear={true}
                                  placeholder="姓名"
                                  ref={inputRef}
                                  defaultValue={currentEmployee.name}
                                  style={{
                                    width: "110px",
                                    marginRight: "12px"
                                  }}
                                  onChange={(e) => {
                                    userNameVal = e.target.value;
                                  }}
                                />
                                <TextArea
                                  id="TextRef"
                                  placeholder="接龙内容"
                                  autoSize={{
                                    minRows: 1,
                                    maxRows: 4
                                  }}
                                  maxLength={100}
                                  style={{
                                    resize: "none"
                                  }}
                                  onChange={(e) => {
                                    setdescCon(e.target.value);
                                  }}
                                />
                              </div>
                            </Form.Item>
                          </Form.Item>
                        );
                      })}
                      {tiems === false && loading === false && (
                        <Form.Item>
                          <div
                            className="con-bom-add"
                            ref={btn}
                            onClick={() => {
                              let isGroups = solitaire.solitaire?.solitaireUserList?.map(
                                (item: any) => {
                                  if (
                                    item.userId === currentEmployee.userId &&
                                    item.teamId === currentEmployee.teamId
                                  ) {
                                    return "false";
                                  }
                                }
                              );
                              if (isGroups?.includes("false") || fields.length > 0) {
                                toast.error({
                                  content: "该接龙不允许每人接龙多次",
                                  key: 1
                                });
                                return;
                              }
                              add();
                              setdisabled(true);
                            }}
                          >
                            <IconFont
                              type="iconic_button_zjl_tianjia"
                              className="chat-aggregation-icon"
                              clstag="pageclick|keycount|focus_chat_01_1615797500283|77"
                            />
                            <span style={{ marginLeft: "12px" }}>添加选项</span>
                          </div>
                        </Form.Item>
                      )}
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
          </>
        ) : (
          <div style={{ position: "absolute", top: "50%", left: "45%" }}>
            <Spin tip="发送中..." spinning={isloading} />
          </div>
        )}
        <Modal
          title="提示"
          className="removeModal"
          width={360}
          visible={isModalOpen}
          onOk={handleOk}
          onCancel={() => {
            setIsModalOpen(false);
          }}
          okText="确定"
          cancelText="取消"
          maskClosable={true}
          centered
        >
          <p style={{ textAlign: "center" }}>确定删除该群接龙么？</p>
          <p style={{ textAlign: "center" }}>删除后将无法恢复。</p>
        </Modal>
      </Drawer>
    </>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const {
    sessionMessageMap,
    connectState,
    currentEmployee,
    SolitaireDetailsVisible,
    solitaireId,
    SolitaireHisVisible
  } = chat;

  return {
    sessionMessageMap,
    connectState,
    currentEmployee,
    SolitaireDetailsVisible,
    solitaireId,
    SolitaireHisVisible
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    openSolitaireDetails(data: { isvisibles: boolean; solitaire: any }) {
      dispatch({ type: "chat/openSolitaireDetails", payload: data });
    },
    openSolitaireHis(data: { isvisibles: boolean; solitaireSid: any }) {
      dispatch({ type: "chat/openSolitaireHis", payload: data });
    },
    openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => {
      dispatch({
        type: "supervise/setCreateModalVisible",
        payload: opt
      });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SolitaireDetails);
